import { setReviewField } from 'feature/claims/claimSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Box, FormControl, TextField, Typography } from 'styles';
import { REVIEW_FIELDS } from 'types/Claim';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const STRING_LIMIT = 500;

const Notes = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { claimData } = useSelector((store: RootState) => store.claim);

	const handleChange = (value: string) => {
		if (value?.length > STRING_LIMIT) {
			return;
		}

		dispatch(setReviewField({ name: REVIEW_FIELDS.INTERNAL_NOTE, value: value }));
	};

	return (
		<FormControl fullWidth>
			<TextField
				name={REVIEW_FIELDS.INTERNAL_NOTE}
				type="text"
				label={tClientLabels('claim.review.notes')}
				onChange={e => handleChange(e.target.value)}
				autoComplete={'off'}
				required
				value={claimData.receipt[REVIEW_FIELDS.INTERNAL_NOTE]}
			/>
			<Box mt={'12px'} ml={'16px'}>
				<Typography variant="caption">
					{`${
						claimData.receipt[REVIEW_FIELDS.INTERNAL_NOTE].length
					}/${STRING_LIMIT}`}
				</Typography>
			</Box>
		</FormControl>
	);
};

export default Notes;
